function shortKeyMatches(key, e) {
    return !!key.shortKey == (e.ctrlKey || e.metaKey);
}
function shiftKeyMatches(key, e) {
    return !!key.shiftKey == e.shiftKey;
}
function altKeyMatches(key, e) {
    return !!key.altKey == e.altKey;
}
function codeMatches(key, e) {
    return key.code == e.code;
}
function matches(key, e) {
    return codeMatches(key, e) && shortKeyMatches(key, e)
        && shiftKeyMatches(key, e) && altKeyMatches(key, e);
}
export function addKeyboardBinding(key, action, eventTarget = window) {
    eventTarget.addEventListener("keydown", (e) => {
        if (matches(key, e)) {
            e.preventDefault();
            action();
        }
    });
}
